"use client";
import React, { useState, useEffect } from "react";
import HomePageService from "@/services/api/HomeService";
import Image from "next/image";
import Link from "next/link";
import { LuChevronRight } from "react-icons/lu";
import CommonImage from "@/components/common/image/CommonImage";
import SkeletonStudentReviewSection from "@/components/common/skeletons/SkeletonStudentReviewSection";
import { usePublicFetch } from "@/hook/usePublicFetch";
import { slugy } from "@/utils/slugify";

export default function StudentReviewSection({ studentReviews }) {
  return (
    <>
      <section className="success-student_section section_padding">
        <div className="container">
          <div className="section_title sm:mx-auto sm:text-center">
            <h2 className="title sm:justify-center">
              <span className="w-8 h-8">
                <CommonImage
                  src="/images/admission-icon/student-success-icon.png"
                  className="img-icon"
                  alt="Book Icon"
                />
              </span>
              শিক্ষার্থীদের অভিমত
            </h2>
            <p className="short-des">
              ফোকাস - যেখানে একাডেমিক সাফল্যের পথ তৈরি হয়। অভিজ্ঞ শিক্ষকদের
              গাইডলাইন, নিয়মিত পরীক্ষার ব্যবস্থা এবং টপিকভিত্তিক অনুশীলনের
              মাধ্যমে আমরা গড়ে তুলি ভবিষ্যতের চ্যাম্পিয়ন।
            </p>
          </div>

          <div className="section-content-wrap">
            <div className="students-opinions">
              {studentReviews?.map((review, index) => (
                <Link
                  href={`/reviews/${review?.id}/${slugy(review.name)}`}
                  className="student-opinion"
                  key={index}
                >
                  <div className="student-information">
                    <CommonImage
                      src={review.image || "/images/home/student-image.png"}
                      className="student-image"
                      alt="Student Image"
                    />

                    <div className="name-title">
                      <h3 className="name">{review.name}</h3>
                      <p className="title">{review.relation}</p>
                    </div>
                  </div>
                  <div className="opinion">
                    <p className="opinion-text">
                      {" "}
                      {review?.description.length > 100
                        ? review.description.substring(0, 100) + "..."
                        : review.description}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
            <div className="text-center mt-5">
              <Link href="/reviews" className="seemore-btn">
                আরো দেখুন <LuChevronRight />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
